import type { PageName } from '@ms/yammer-telemetry-support';
import type { StoreApi } from 'zustand/vanilla';
import { createStore } from 'zustand/vanilla';

import type { PageLoadEventData } from './loadEvents';

interface FirstLoadedPageState {
  readonly firstLoadedPage: PageName | undefined;
  readonly updateFirstLoadedPageIfNecessary: (data: PageLoadEventData) => void;
  readonly debugResetFirstLoadedPage: () => void;
}

const precachePages = ['Precache', 'EmptyStart'];
export const isPrecachePage = (page: PageName): boolean => precachePages.includes(page);

export const firstLoadedPageStore: StoreApi<FirstLoadedPageState> = createStore<FirstLoadedPageState>((set, get) => ({
  firstLoadedPage: undefined,

  updateFirstLoadedPageIfNecessary: ({ page }: PageLoadEventData) => {
    const { firstLoadedPage } = get();

    if (!firstLoadedPage) {
      set({ firstLoadedPage: page });

      return;
    }

    if (isPrecachePage(firstLoadedPage)) {
      set({ firstLoadedPage: page });
    }
  },

  debugResetFirstLoadedPage: () => {
    set({ firstLoadedPage: undefined });
  },
}));

export const updateFirstLoadedPageIfNecessary = (data: PageLoadEventData): void =>
  firstLoadedPageStore.getState().updateFirstLoadedPageIfNecessary(data);
export const debugResetFirstLoadedPage = (): void => firstLoadedPageStore.getState().debugResetFirstLoadedPage();
